module.exports = __webpack_public_path__ + "img/copihue.ffef0cea.svg";